"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyQuery = void 0;
/**
 * Build query params string using URLSearchParams
 * @param params
 * @returns {string}
 */
const stringifyQuery = (params) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) {
            searchParams.append(key, String(value));
        }
    });
    if (searchParams.size > 0) {
        return `?${searchParams.toString()}`;
    }
    else {
        return '';
    }
};
exports.stringifyQuery = stringifyQuery;
//# sourceMappingURL=urlQuery.js.map